import ModalDisable from '@/components/ui/custom/modals/ModalDisable';

type ModalRemoveResourceProps = {
  onConfirm(): void;
  onCancel(): void;
  loading?: boolean;
  visible?: boolean;
};

export default function ModalRemoveResource(props: ModalRemoveResourceProps) {
  const { onCancel, onConfirm, loading, visible = false } = props;

  return (
    <ModalDisable
      testId="modalRemoveResource"
      isRequesting={loading}
      visible={visible}
      translationString="deleteResource"
      onClickConfirm={onConfirm}
      onClickCancel={onCancel}
      modalType="delete"
    />
  );
}
